import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericDocContainerModel, GenericDocHdrLineOpenQueueImportContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})
export class InternalShoppingCartsService extends BaseApiPublicLoginTemplateService<GenericDocContainerModel, GenericDocContainerModel, GenericDocContainerModel> {
  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-shopping-carts';
  constructor(http: HttpClient) {
    super(); 
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-shopping-carts';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-shopping-carts';
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-shopping-carts/' + BaseApiPublicLoginTemplateService.LOGIN_EP;
    this.endpoint_path_login_entity_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-shopping-carts/' + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
  
    this.httpClient = http;
  }

  public getGenericDocHdrLineLinkImportByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocHdrLineOpenQueueImportContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-imports/internal-shopping-carts`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocHdrLineOpenQueueImportContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  public getOutstandingItems(dto: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/outstanding-items/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl, dto, this.getHttpHeader(visa)
    );
  }
}
